// sites.$siteId.risks.new.tsx — T046
// Route : /sites/:siteId/risks/new → formulaire création
// Guard : vérifie canAddRisk pour la création via composant.

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { z } from "zod";

import { usePermissions } from "@/application/hooks/usePermissions";
import { RiskFormPage } from "@/presentation/pages/RiskFormPage";

import { Route as SiteRoute } from "./sites.$siteId";

const riskNewSearchSchema = z.object({
  workUnitId: z.string().min(1).optional(),
});

interface RiskNewSearch {
  workUnitId?: string;
}

// /sites/:siteId/risks/new — création
export const Route = createFileRoute("/sites/$siteId/risks/new")({
  validateSearch: (search: Record<string, unknown>): RiskNewSearch => {
    const parsed = riskNewSearchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
  },
  component: function RiskNewRouteComponent() {
    const { siteId } = Route.useParams();
    const { site } = SiteRoute.useLoaderData();
    const { workUnitId } = Route.useSearch();
    const navigate = useNavigate();
    const permissions = usePermissions();

    useEffect(() => {
      if (!permissions.duerp.canAddRisk(siteId, site.regionId)) {
        void navigate({ to: "/sites/$siteId", params: { siteId } });
      }
    }, [site.regionId, siteId, permissions, navigate]);

    if (!permissions.duerp.canAddRisk(siteId, site.regionId)) {
      return null;
    }

    return <RiskFormPage siteId={siteId} initialWorkUnitId={workUnitId} />;
  },
});
